import React from "react";
import { PieChart, Pie, Cell } from "recharts";

const RADIAN = Math.PI / 180;
const data = [
  { name: "A", value: 46, color: "#ff0000" },
  { name: "B", value: 85, color: "#00ff00" },
  { name: "C", value: 25, color: "#0000ff" },
];
const cx = 150;
const cy = 200;
const iR = 50;
const oR = 100;
const value = 50;

const Needle = ({ value, data, cx, cy, iR, oR, color }) => {
  let total = 0;
  data.forEach((v) => {
    total += v.value;
  });
  const ang = 180.0 * (1 - value / total);
  const length = oR - iR + 10; // Adjusting the length of the needle for better visibility
  const sin = Math.sin(-RADIAN * ang);
  const cos = Math.cos(-RADIAN * ang);
  const x0 = cx;
  const y0 = cy;
  const xp = x0 + length * cos;
  const yp = y0 + length * sin;

  return (
    <>
      <circle cx={x0} cy={y0} r={5} fill={color} stroke="none" />
      <path d={`M${x0} ${y0} L${xp} ${yp}`} stroke={color} strokeWidth="3" />
    </>
  );
};

const Example = () => {
  return (
    <PieChart width={400} height={500}>
      <Pie
        dataKey="value"
        startAngle={180}
        endAngle={0}
        data={data}
        cx={cx}
        cy={cy}
        innerRadius={iR}
        outerRadius={oR}
        fill="#8884d8"
        stroke="none"
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.color} />
        ))}
      </Pie>
      <Needle
        value={value}
        data={data}
        cx={cx}
        cy={cy}
        iR={iR}
        oR={oR}
        color="#d0d000"
      />
    </PieChart>
  );
};

export default Example;
